import { Link, useSearchParams } from "react-router-dom";
import AfterSalesLayout from "../aftersaleslayout/AfterSalesLayout";
import FallbackImg from "../../../components/FallbackImg";
import Policy from "../../../assets/aftersalesservice_icons/policy.svg";
import Download from "../../../assets/aftersalesservice_icons/warranty_download.svg";
import Correct from "../../../assets/aftersalesservice_icons/correct.svg";
import Wrong from "../../../assets/aftersalesservice_icons/wrong.svg";
import BackBlue from "../../../assets/aftersalesservice_icons/back_blue_icon.svg";
import { useLanguage } from "../LanguageContext";
import { buildAfterSalesQuery } from "../serialTypeUtils";

const WarrantyPolicy = () => {
  const { trans } = useLanguage();
  const [searchParams] = useSearchParams();
  const sn = atob(searchParams.get("sn") || "");
  const getSerialNo = () => sn;

  const openPdf = () => {
    window.open(
      "https://file.unity.net.my/document/Philips%20Air%20Conditioner%20-%20Warranty%20Policy.pdf",
      "_blank",
    );
  };

  const goBack = (e) => {
    e.preventDefault();
    window.history.back();
  };

  return (
    <AfterSalesLayout>
      <div className="as-warranty-policy-content" id="warranty_policy_modal">
        <div className="as-warranty-policy-container">
          <div style={{ padding: "0 31.97px" }}>
            <div className="as-warranty-policy-card">
              <a
                className="as-back-btn"
                id="warranty_policy_back"
                href="#"
                onClick={goBack}
              >
                <FallbackImg
                  src={BackBlue}
                  className="as-back_blue_icon"
                  alt="back"
                />
                {trans.back}
              </a>

              <div className="as-card-header">
                <FallbackImg
                  src={Policy}
                  className="as-warranty_icon"
                  alt="policy"
                />

                <div className="as-text">
                  <h2>{trans.warr_policy}</h2>
                  <p className="as-warranty-policy-subtitle">
                    {trans.warr_policy_sub}
                  </p>
                </div>
              </div>

              <button
                className="as-download-btn"
                type="button"
                onClick={openPdf}
              >
                <FallbackImg
                  src={Download}
                  className="as-download_icon"
                  alt="download"
                />
                {trans.download_policy}
              </button>
            </div>

            <div className="as-section">
              <h3 className="as-title as-green">
                <FallbackImg
                  src={Correct}
                  className="as-correct_wrong_icon"
                  alt="correct"
                />
                {trans.whats_cover}
              </h3>

              <ul className="as-list as-green-list">
                <li>{trans.whats_cover_sub_1}</li>
                <li>{trans.whats_cover_sub_2}</li>
                <li>{trans.whats_cover_sub_3}</li>
                <li>{trans.whats_cover_sub_4}</li>
                <li>{trans.whats_cover_sub_5}</li>
                <li>{trans.whats_cover_sub_6}</li>
              </ul>
            </div>

            <div className="as-section">
              <h3 className="as-title as-red">
                <FallbackImg
                  src={Wrong}
                  className="as-correct_wrong_icon"
                  alt="wrong"
                />
                {trans.whats_not_cover}
              </h3>

              <ul className="as-list as-red-list">
                <li>{trans.whats_not_cover_sub_1}</li>
                <li>{trans.whats_not_cover_sub_2}</li>
                <li>{trans.whats_not_cover_sub_3}</li>
                <li>{trans.whats_not_cover_sub_4}</li>
                <li>{trans.whats_not_cover_sub_5}</li>
                <li>{trans.whats_not_cover_sub_6}</li>
                <li>{trans.whats_not_cover_sub_7}</li>
              </ul>
            </div>

            <div className="as-contact-card">
              <p>
                {trans.ques_warr}
                <br />
                {trans.our_sup_1}
              </p>

              <Link
                to={`/aftersalesservice/ticketsubmission${buildAfterSalesQuery(
                  searchParams,
                  {
                    type: "Technical_Consultation_Inquiry",
                  },
                )}`}
              >
                <button className="as-contact-btn" type="button">
                  {trans.contact_sup}
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </AfterSalesLayout>
  );
};

export default WarrantyPolicy;
